module.exports = __webpack_public_path__ + "img/pie-chart.d9de808d.svg";